module.exports = __webpack_public_path__ + "img/slide_7.806d5ee1.webp";